import React from 'react';
import changeProviderProvider from 'mn-utils/changeProviderProvider';
import onEnterProvider from 'mn-utils/onEnterProvider';
import throttle from 'mn-utils/throttle';
import getTime from 'mn-utils/time';
import numberHandle from '../../../../../../utils/numberHandle';
import {
  apiAuthTfaBind,
  apiAuthTfaConfirm,
} from '../../../../../../api/_auth';
import {
  openPopupWindow,
  openPopupInfo,
} from '../../../../../../emitters/popup';
import Popup from '../../../../../dumb/Popup/B';
import TextField from '../../../../../dumb/TextField/A';
import CodeFields from '../../../../../dumb/CodeFields';
import Field from '../../../../../dumb/Field/E';
import FieldId from '../../../../../dumb/Field/IdA';
import ButtonN from '../../../../../dumb/Button/Accept';
import WrapperWithLoading from '../../../../../dumb/WrapperWithLoading/B';
import ButtonM from "../../../../../dumb/Button/Decline";
import {replaceLocation} from "../../../../../../router";
import {LINK_PAYMENT_LINK} from "../../../../../../constants/links";


const bind2FA = throttle(apiAuthTfaBind, 1000);


module.exports = (data, callback) => {
  data = data || {};

  openPopupWindow((setState, self, onMount) => {
    let _nodeCode;
    const {
      close,
    } = self;
    const handleChangeCode
      = changeProviderProvider(setState)('code', 0, numberHandle);

    function handleCodeRef(node) {
      node && (_nodeCode = node);
    }

    onMount(() => {
      setState({
        loading: true,
      });
      return bind2FA({
        skipError: 1,
      }).finally((error, bind) => {
        setState({
          loading: false,
          error,
          bind,
          time: getTime(),
        });
      }).cancel;
    });


    return (state) => {
      const clicked = state.clicked || false;
      const code = (state.code || '').substr(0, 6);
      const time = state.time;
      const bind = state.bind || {};
      const qrcodeUrl = bind.qrcode_url || '';
      const requestError = state.error || {};
      const codeLengthError = code.length !== 6;
      const disabled = codeLengthError;

      function handleSubmit() {
        _nodeCode && _nodeCode.blur();
        if (disabled) {
          setState({
            clicked: true,
          });
          return;
        }

        setState({
          loading: true,
        });
        apiAuthTfaConfirm({
          // skipError: 1,
          code,
        })
            .finally((error) => {
              setState({
                loading: false,
                clicked: true,
                error,
              });
              if (error) {
                return;
              }

              close();
              openPopupInfo(['The two-factor authentication code is set']);
              callback();
            });
      }

      return (
        <Popup
          caption="Set 2FA Code"
        >
          <WrapperWithLoading
            loading={state.loading}
          >
            <div className="cfx mt20 mh-28 (lt|ph28|w1/2|w@m2)>1">
              <div className="pb50">
                <div className="layoutRow fhaC fvaC hmin260 ov">
                  {qrcodeUrl ? (
                    <img
                      className="wmax w260"
                      src={'/v1/auth/tfa/qrcode?t=' + time}
                    />
                  ) : null}
                </div>
                <div className="tc">
                  Scan the QR code through the Google Authenticator app
                </div>
              </div>
              <div>
                <Field label="2FA setup key">
                  <FieldId
                    className="tc"
                    value={bind.secret}
                  />
                </Field>
                <div className="mt20">
                  <CodeFields
                    label="Enter the 6 digit authentication code"
                    codeLength={6}
                    value={code}
                    onChange={(e) => {
                      if (requestError.message) setState({error: {}});
                      handleChangeCode(e);
                    }}
                    onSubmit={handleSubmit}
                    error={clicked && (codeLengthError || requestError.message)}
                    helperText={codeLengthError ? "Must be 6 digits" : requestError.message}
                  />
                </div>

                {/*<TextField*/}
                {/*  className="mt50"*/}
                {/*  label="Enter the 6 digit authentication code"*/}
                {/*  inputRef={handleCodeRef}*/}
                {/*  error={clicked && disabled}*/}
                {/*  value={code}*/}
                {/*  onChange={handleChangeCode}*/}
                {/*  onKeyPress={onEnterProvider(handleSubmit)}*/}
                {/*  maxLength={6}*/}
                {/*  helperText="Must be 6 digits"*/}
                {/*/>*/}
              </div>
            </div>
            <div className="mt0 cfx mh-28 (lt|ph28|pb20)>1">
              <div>
                <ButtonN
                  disabled={clicked && disabled}
                  onClick={handleSubmit}
                >Set 2FA Code</ButtonN>
              </div>
              <div>
                <ButtonM
                  onClick={close}
                >Cancel</ButtonM>
              </div>
            </div>
          </WrapperWithLoading>
        </Popup>
      );
    };
  });
};
